
export default {
  SET_SMSC_LIST(state, { smscList, total, per_page }) {
    state.smscList = smscList;
    state.totalPage = total / per_page;
    state.totalItems = total;
  },

  ADD_SMSC(state, data){
    state.smscList.unshift(data);
  },

  REMOVE_SMSC(state, id) {
    state.smscList = state.smscList.filter(item => item.smsc_id !== id);
  },
  SET_SMSC(state, smsc) {
    state.smsc = smsc;
  },
};
